import React from 'react';

import styled from '@emotion/styled';

import { FontWeight } from '@clutter/clean';

import { CHALLENGER_FORM_INCOMPLETE_ERROR } from './completion';
import { CHALLENGER as T } from './tokens';

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${T.space[12]};
  width: 100%;
`;

const ErrorBanner = styled.div`
  width: 100%;
  padding: ${T.space[12]};
  box-sizing: border-box;
  border-radius: ${T.radius.xs};
  background: rgba(231, 76, 60, 0.12);
  font-family: ${T.font.sans};
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 20px;
  color: ${T.color.textPrimary};
`;

const ContinueButton = styled.button<{ disabled?: boolean }>`
  appearance: none;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: ${T.radius.md};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background: ${({ disabled }) =>
    disabled ? T.color.bgButtonDisabled : T.color.textBrand};
  color: ${({ disabled }) =>
    disabled ? T.color.textDisabled : T.color.textInverse};
  font-family: ${T.font.sans};
  font-size: 16px;
  font-weight: ${FontWeight.Semibold};
  line-height: 16px;
  padding: 0 ${T.space[24]};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 1 : 0.92)};
  }
`;

const Note = styled.p`
  margin: 0;
  font-family: ${T.font.sans};
  font-size: 12px;
  font-weight: ${FontWeight.Medium};
  line-height: 16px;
  color: ${T.color.textTertiary};
  text-align: center;
`;

type Props = {
  disabled: boolean;
  loading?: boolean;
  onContinue: () => void | Promise<void>;
  showError?: boolean;
  errorMessage?: string;
};

/** Primary Continue CTA at the bottom of the challenger plan form. */
export const FormContinue: React.FC<Props> = ({
  disabled,
  loading = false,
  onContinue,
  showError = false,
  errorMessage = CHALLENGER_FORM_INCOMPLETE_ERROR,
}) => (
  <Block>
    {showError && <ErrorBanner role="alert">{errorMessage}</ErrorBanner>}
    <ContinueButton
      type="button"
      disabled={disabled || loading}
      onClick={() => void onContinue()}
    >
      Continue
    </ContinueButton>
    <Note>You will be charged at the completion of your pickup.</Note>
  </Block>
);
